import React from "react";
import { Colors, Classes } from "@blueprintjs/core";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import { getURLSearch } from "app/utils";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

let DefaultContent = props => {
  const { staticContext, ...rest } = props;
  const urlSearch = getURLSearch();
  return (
    <div {...rest}>
      <FooterLinks>
        <Link to={"/help" + urlSearch} className="pt-button pt-minimal">
          <FormattedMessage id="app.footer.help" defaultMessage="Help" />
        </Link>
        <span className="pt-navbar-divider" />
        <Link to={"/contact" + urlSearch} className="pt-button pt-minimal">
          <FormattedMessage id="app.footer.contact" defaultMessage="Contact" />
        </Link>
        <span className="pt-navbar-divider" />
        <Link to={"/imprint" + urlSearch} className="pt-button pt-minimal">
          <FormattedMessage id="app.footer.imprint" defaultMessage="Imprint" />
        </Link>
        <span className="pt-navbar-divider" />
        <Link to={"/privacy" + urlSearch} className="pt-button pt-minimal">
          <FormattedMessage
            id="app.footer.privacy"
            defaultMessage="Privacy Notice"
          />
        </Link>
      </FooterLinks>
      <div style={{ marginTop: "15px" }} />
    </div>
  );
};

const enhance = compose(withRouter);

DefaultContent = styled(DefaultContent)`
  width: 290px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
`;

DefaultContent = enhance(DefaultContent);

const FooterLinks = styled.div`
  // width: 100%;
`;

const Footer = styled.div.attrs({
  children: (
    <DefaultContent
      className={`{${Classes.DARK} ${Classes.NAVBAR_GROUP} pt-align-center`}
    />
  )
})`
  min-height: 4em;
  background-color: ${Colors.GRAY3};
  padding: 1em;
  text-align: center;
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/app/Footer.js